
import Component, { mixins } from 'vue-class-component'
import NewsMixin from './news-mixin/index'
import NewsItem from '@/components/news-item/index.vue'
import ItemTitle from '@/components/item-title/index.vue'
import { Prop, Watch } from 'vue-property-decorator'
import { InformationNewsManageImpl } from '../manages/InformationNewsManageImpl'
import { InformationNewsService } from '../services/HomeService'
@Component({
  components: {
    ItemTitle,
    NewsItem
  }
})

export default class Index extends mixins(NewsMixin) {
  private manage = new InformationNewsManageImpl(new InformationNewsService())
  @Prop() private list!: Array<any>
  @Prop() private pid!: string
  @Prop() private targetIndex!: number
  private projlist = []
  private isShowMore = false
  private posterIndexs = [3]

  mounted () {
    (this.projlist as any) = this.list ? this.list.slice(0, 10) : []
    console.log(this.list)
  }

  showDetail (info: any) {
    console.log(this.pid, info)
    // localStorage.setItem('selectedChapter', JSON.stringify([this.pid, info.projectSystemId]))
    // window.location.href = (`/study.html#/?id=${info.projectSystemId}`)
    // localStorage.setItem('selectedChapter', JSON.stringify([this.pid, info.categoryId]))
    const url = process.env.VUE_APP_PROD_URL
    const tags: string[] = [this.pid, info.categoryId]
    window.location.href = (url + `/study.html#/?tags=${tags.join(',')}`)
  }

  get more () {
    return this.list ? this.list.length > 10 : [] && !this.posterIndexs.includes(this.targetIndex)
  }

  viewMore () {
    this.isShowMore = !this.isShowMore
    if (this.isShowMore) {
      (this.projlist as any) = [...this.list]
    } else {
      (this.projlist as any) = this.list.slice(0, 10)
      window.location.href = '#projects'
    }
  }
}
